import React from 'react';
import logo from '../../img/logoResized.png';
import tagline from '../../img/tagline.png';

const Header = () => {
  return (
    <>
      <div className='flex flex-row justify-center items-center mt-4'>
        <div className='flex items-center'>
          <img
            className='object-center h-24 w-24 sm:h-24 sm:w-24'
            src={logo}
            alt='SmartInv logo'
          />
          <img
            className='object-center h-12 w-32 mt-4 sm:h-12 sm:w-36'
            src={tagline}
            alt='SmartInv Tagline'
          />
        </div>
      </div>
    </>
  );
};

export default Header;
